import React, { useState, useEffect, useRef } from "react";
import { Accordion, Card } from "react-bootstrap";
import Portfoliosidebar from "../Sidebar/Portfoliosidebar";
import TopNavbar from "../../Investor/Navabr/navbar";
import "./interest.css";
import { FaTh, FaServer } from "react-icons/fa";

import { interestList } from '../../../controllers/interest/interestController';
import { Skeleton } from "antd";
import { Link} from "react-router-dom";

import AcceptPopUp from './Popup'
import DeclinePopUp from './DeclinePopup'
import NoDataFound from "./NoDataFound";
import { createImageFromInitials } from "../../../controllers/common";
const Companiesportfolio = () => {
  const targetRef = useRef();
  const [activeAccordion, setActiveAccordion] = useState("0");
  const handleAccordionClick = (eventKey) => {
    setActiveAccordion(activeAccordion === eventKey ? null : eventKey);
  };

  const USERDATA = JSON.parse(sessionStorage.getItem('USER-INFO'));

  const [isSelectShow, setIsSelectShow]= useState(false);
  const handleIsSelectShow =() => setIsSelectShow(!isSelectShow);

  const [isDeclineShow, setIsDeclineShow]= useState(false);
  const handleIsDeclineShow =() => setIsDeclineShow(!isDeclineShow);

  const [dataView, setDataView]= useState('table');

  const [isLoading, setIsLoading] = useState(true)
  const [interestId, setInterestId] = useState('');
  const [interest, setInterest] = useState('');
  const [searchText, setSearchText] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [showStatus, setShowStatus] = useState('');
  const toggleExpand = (index) => {
    setExpanded((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  
  const getInterestList = async () =>{
    try {
      setIsLoading(true);
      setInterest([]);
      const options = {
        ...(searchText?{searchText : searchText}:null),
        condition : { 
          company_data : USERDATA._id,
          admin_status : "A",
          ...(showStatus?{status : showStatus}:null)
        }
      }
      const res = await interestList(options);
      if(res.status === true){
        setInterest(res.result);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setInterest([]);
    }
  }

  const handleAccept=(id)=>{ 
    setInterestId(id);
    handleIsSelectShow();
  }

  const handleDecline=(id)=>{ 
    setInterestId(id);
    handleIsDeclineShow();
  }

  const handleSearchChnage = (e) =>{
    const {value} = e.target;
    if(e.key === 'Enter'){
      handleSearch(e);
    }else{
      setSearchText(value);
    }
  }
  const handleSearch = (e) => {
    e.preventDefault();
    // if(searchText.length > 0){
      setIsSearch(!isSearch);
    // }
  }

  useEffect(()=>{
    getInterestList();
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = "Chiratae Ventures | Spotlight | Interest list";
  },[isSelectShow,showStatus, isDeclineShow, isSearch]);
  return (
    <React.Fragment>
      <TopNavbar></TopNavbar>
      <div className="main-wrapper" ref={targetRef}>
        <div>
          <Portfoliosidebar></Portfoliosidebar>
        </div>
        <div className="main_contant">
          <div className="container-fluid all_page_for_top_heading">
            <h2 className=" text-uppercase all_heading">Interest</h2>
          </div>
          <div className="container-fluid all_page_for_top_heading">
            <form onSubmit={handleSearch}>
              <div className="row">
                <div className="col-sm-9 col-md-9 col-lg-9">
                  <input className="form-control all_input" type="text" name="search" id="search" onChange={handleSearchChnage} value={searchText} placeholder="Search interest..."/>
                </div>
                
                <div className="col-sm-2 col-md-2 col-lg-2">
                  <div className="profile_submit_btn">
                    <button type="submit" id="selected">Search</button>
                  </div>
                </div>

                <div className="col-sm-1 col-md-1 col-lg-1">
                  {dataView === 'table' ? (
                    <div title="Grid view"  className="profile_submit_btn" onClick={()=>setDataView('grid')}>
                      <button type="button" id="selected"><FaTh/></button>
                    </div>
                  ) : (
                    <div title="Table view" className="profile_submit_btn" onClick={()=>setDataView('table')}>
                      <button type="button" id="selected"><FaServer/></button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
          <div className="companies_section_main_div mb-3">
            <div className="d-flex align-items-center justify-content-between companies_select_all_div">
            <div className="profile_submit_btn">
                <div className="started_in_mint_ago">
                  <button type="button" onClick={()=>setShowStatus('')}>All</button>
                  <button type="button" onClick={()=>setShowStatus('P')}>Pending</button>
                  <button type="button" onClick={()=>setShowStatus('A')}>Accepted</button>
                  <button type="button" onClick={()=>setShowStatus('R')}>Declined</button>
                </div>
            </div>
            </div>
          </div>
          {interest?.length > 0 ? (
            dataView ==='grid' ?(
              interest.map((items, index) => (
                <div className="container-fluid companies_section_main_div mb-3">
                  <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                    <div className="d-flex align-items-center companies_beep_cart_img">
                      {/* {items?.investor_data?.investor_image?(
                        <img
                          src={items?.investor_data?.investor_image}
                          alt="Company Logo"
                          className="rounded"
                          style={{ marginRight: "10px" }}
                        />
                      ):(
                        <img
                          src={createImageFromInitials(100, `${items?.investor_data?.investor_firm_name?.length > 8?items.investor_data.investor_firm_name.substring(0,8)+'..':items?.investor_data?.investor_firm_name}`, '#ededed')}
                          alt="Company Logo"
                          className="rounded"
                          style={{ marginRight: "10px" }}
                        />
                      )} */}
                      <div>
                        <h6 className="mb-0" style={{ fontSize: "16px" }}>
                        {`${items?.investor_data?.investor_firm_name}`}
                        </h6>
                        {/* <small className="text-muted">{`${items?.investor_data?.investor_first_name} ${items?.investor_data?.investor_last_name}`}</small> */}
                        <small className="text-muted">{items?.investor_users?.investor_first_name} {items?.investor_users?.investor_last_name?.length > 30 ?`${items?.investor_users?.investor_last_name.substring(0,12)}...`:`${items?.investor_users?.investor_last_name}`}</small>
                      </div>
                    </div>
                    <div className="profile_submit_btn">
                      {items?.status === 'A'?
                        <button type="button" id="selected">Accepted</button>:
                        items?.status === 'C'?
                        <button type="button" id="selected">Cancelled</button>:
                        items?.status === 'R'?
                        <button type="button" id="selected">Declined</button>:(
                          <>
                          <button type="button" className="mx-2" onClick={()=>handleAccept(items?._id)}>Accept</button>
                          <button type="button" onClick={()=>handleDecline(items?._id)}>Decline</button>
                          </>
                        )
                      }
                    </div>
                  </div>
                  <Accordion
                    activeKey={activeAccordion}
                    onSelect={handleAccordionClick}
                    className="companies_accrodian"
                  >
                    <Card
                      style={{ border: "1px solid #e0e0e0", borderRadius: "8px" }}
                    >
                      <Accordion.Item eventKey={index} className="company_accodian_item">
                        <Accordion.Header>
                          <span>About the investor</span>
                        </Accordion.Header>
                        <Accordion.Body
                          style={{ padding: "1rem" }}
                          className="companies_border_top"
                        >
                          <p>
                            Firm Name : <span>{items?.investor_data?.investor_firm_name?items?.investor_data?.investor_firm_name:''}</span>
                          </p>
                          <p>
                            Investor Name : <span>{`${items?.investor_users?.investor_first_name} ${items?.investor_users?.investor_last_name}`}</span>
                          </p>
                          <p>
                            Designation : <span>{items?.investor_users?.investor_designation ? items?.investor_users?.investor_designation :''}</span>
                          </p>
                          <p>
                            {expanded[index]?
                              <span>
                                {`${items?.investor_data?.investor_description} `}
                              </span> : <span>
                              {`${items?.investor_data?.investor_description.slice(0, 175)} `}
                              </span>}
                              {items?.investor_data?.investor_description?.length > 175 && (
                                <Link type="button" onClick={() => toggleExpand(index)}>
                                  {expanded[index] ? 'Read less' : 'Read more'}
                                </Link>
                            )}
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Card>
                  </Accordion>
                </div>
              ))
            ):(
              <div id="content-wrapper" className="d-flex flex-column">
                <div className=" mb-4">
                  <div className="card-body pt-0">
                    <div className="table-responsive">
                    <table
                        className="table table-bordered text-center"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                        >
                        <thead>
                          <tr>
                            <th>Sr. no.</th>
                            <th>Investor</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Actions</th>
                          </tr>
                        </thead>

                        <tbody>
                          {interest.map((items, index) => (
                            <tr key={index}>
                              <td>{index +1}</td>
                              <td className="admin_user_list_date"> {items?.investor_data?.investor_firm_name} </td>
                              {/* <td className="admin_user_list_date"> {items?.investor_users?.investor_first_name} </td> */}
                              <td className="admin_user_list_date">
                                {items?.investor_users?.investor_first_name}
                                {items?.investor_users?.investor_last_name
                                  ? ` ${items.investor_users.investor_last_name}`
                                  : ""}
                              </td>
                              <td className="admin_user_list_date"> {items?.investor_users?.investor_designation} </td>
                              <td>
                                <div className="profile_submit_btn">
                                  {items?.status === 'A'?
                                    <button type="button" id="selected">Accepted</button>:
                                    items?.status === 'C'?
                                    <button type="button" id="selected">Cancelled</button>:
                                    items?.status === 'R'?
                                    <button type="button" id="selected">Declined</button>:(
                                      <>
                                      <button type="button" className="mx-2" onClick={()=>handleAccept(items?._id)}>Accept</button>
                                      <button type="button" onClick={()=>handleDecline(items?._id)}>Decline</button>
                                      </>
                                    )
                                  }
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )
            ): isLoading ? (<>
              <div className="companies_section_main_div mb-3">
                <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                  <Skeleton avatar />
                </div>
              </div>

              <div className="companies_section_main_div mb-3">
                <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                  <Skeleton avatar />
                </div>
              </div>

              <div className="companies_section_main_div mb-3">
                <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                  <Skeleton avatar />
                </div>
              </div>

              <div className="companies_section_main_div mb-3">
                <div className="d-flex align-items-center justify-content-between companies_select_all_div">
                  <Skeleton avatar />
                </div>
              </div>
            </>):(<NoDataFound/>)}
        </div>
        <AcceptPopUp 
          show={isSelectShow} 
          handleIsSelectShow={handleIsSelectShow} 
          interestId={interestId}
          setInterestId={setInterestId} />

        <DeclinePopUp 
          show={isDeclineShow} 
          handleIsSelectShow={handleIsDeclineShow} 
          interestId={interestId}
          setInterestId={setInterestId} />
      </div>
    </React.Fragment>
  );
}

export default Companiesportfolio;
